import posthog from "posthog-js";
import type FeatureFlag from "../types/FeatureFlag";

// Simple wrapper around PostHog so we don't have to handle the 'undefined' case.
const isFeatureEnabled = (featureFlag: FeatureFlag) => posthog.isFeatureEnabled(featureFlag) === true;

export default isFeatureEnabled;
